import styled from 'styled-components'
import {boxShadow} from "styled-system";
import {Box, Card, Flex, Heading} from 'rebass'

export const Wrapper = styled(Flex)`
	height: 100%;
`

Wrapper.defaultProps = {
	flexDirection: 'column',
	flexWrap: 'wrap'
};


export const TitleSection = styled(Card)`
	//height: 200px;
	min-height: 74px;
`

TitleSection.defaultProps = {
	boxShadow: 'main',
	width: 1,
	py: 3,
	px: 4,
	bg: 'white'
};

export const HeadingWrapper = styled(Flex)`
	min-height: 74px;
`

export const SubHeading = styled(Heading)``

SubHeading.defaultProps = {
	as: 'h5',
	color: 'meta'
};

export const Sidebar = styled(Flex)`
	min-width: 310px;
	max-width: 350px;
	height: 100%;
	min-height: 50vh;
	${boxShadow}
	//margin-top: -5px;
`

Sidebar.defaultProps = {
	boxShadow: '0 3px 6px rgba(0, 0, 0, .16)',
	flexDirection: 'column',
	flexWrap: 'wrap'
};

export const ActiveTabCircle = styled(Box)`
	background-color: #2b80b9;
	border-radius: 50%;
	border: 1px solid #2b80b9;
	width: 12px;
	height: 12px;
`

export const InactiveTabCircle = styled(Box)`
	background-color: white;
	border-radius: 50%;
	border: 1px solid white;
	width: 12px;
	height: 12px;
`

export const TabWrapper = styled(Box)`
	//max-width: calc(100vw - 350px);
	width: calc(100vw - 350px);

`

export const SubcategoryCard = styled(Card)`
min-width: 300px;
`
export const VerticalScroll = styled(Flex)`
  display: flex; /* [1] */
  flex-direction: row;
  flex-wrap: wrap; /* [1] */
  overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}`

SubcategoryCard.defaultProps = {
	px: 3,
	pb: '15px',
	pt: '18px',
	borderRadius: '5px',
	mx: 1,
	boxShadow: 'main'
};

